

class API_KEYS {

    constructor(service, temp, user){
        this.service=service;
        this.temp=temp;
        this.user=user;
    }

    get getService(){
        return this.service;
    }

    get getTemplateId(){
        return this.temp;
    }

    get getUserId(){
        return this.user;
    }
}


export default new API_KEYS(
    "service_4k78h3n", 
    "template_jjzomgr", "6RJC0ZxW3AM09pA5X");